import { render, staticRenderFns } from "./BookIcon.vue?vue&type=template&id=5cba2a1d&scoped=true&"
import script from "./BookIcon.vue?vue&type=script&lang=js&"
export * from "./BookIcon.vue?vue&type=script&lang=js&"
import style0 from "./BookIcon.vue?vue&type=style&index=0&id=5cba2a1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cba2a1d",
  null
  
)

export default component.exports